import { Loader2 } from 'lucide-react'

export function LoadingScreen() {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center">
      <Loader2 className="w-12 h-12 text-claw-primary animate-spin" />
      <p className="mt-4 text-gray-600">加载中...</p>
    </div>
  )
}
